import styled from "styled-components";

export const ParagraphWrapper = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
`;
